import { render, staticRenderFns } from "./FormInputText.vue?vue&type=template&id=56baf1a4&"
import script from "./FormInputText.vue?vue&type=script&lang=js&"
export * from "./FormInputText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports